import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { File } from 'react-pdf/src/shared/types';

// Support for annotations. If you want to use annotations (e.g. links) in PDFs rendered by React-PDF
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// Support for text layer. If you want to use text layer in PDFs rendered by React-PDF,
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface Props {
  url: File;
  width?: number;
  height?: number;
}

const PdfReader: React.FC<Props> = ({ url, width, height }) => {
  const [numPages, setNumPages] = useState(0);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <Document file={url} loading="加载中..." onLoadSuccess={onDocumentLoadSuccess}>
      {new Array(numPages).fill(1).map((e, i: number) => (
        <Page key={i} pageNumber={i + 1} width={width || window.screen.width} />
      ))}
    </Document>
  );
};

export default PdfReader;
